import { Link, useLocation } from 'react-router-dom';
import { mediaList } from '@/mocks/movies';

const columns = [
  { label: '电影', type: '电影', items: ['动作', '喜剧', '剧情', '科幻', '悬疑'] },
  { label: '电视剧', type: '电视剧', items: ['都市', '古装', '悬疑', '年代', '家庭'] },
  { label: '动漫', type: '动漫', items: ['热血', '奇幻', '治愈'] },
  { label: '综艺', type: '综艺', items: ['真人秀', '美食', '音乐'] },
  { label: '纪录片', type: '纪录片', items: ['人文', '自然', '美食'] },
];

export default function SiteFooter() {
  const location = useLocation();
  const hot = [...mediaList].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <footer className="mt-16 bg-secondary-950 text-background-100/80">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_2.6fr]">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-film-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">菠萝蜜网</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/70">
              最新电影电视剧资讯与影视推荐平台。我们把每天更新的影视动态整理成清晰的分类与专题，帮你在信息过载里找到真正想看的那一部。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-mail-line', label: '邮件' },
              ].map((item) => (
                <span
                  key={item.label}
                  aria-label={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/20 text-background-100/70 transition hover:border-accent-400 hover:text-accent-400"
                >
                  <i className={`${item.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5">
            {columns.map((column) => (
              <div key={column.label}>
                <h4 className="text-sm font-medium text-background-50">{column.label}</h4>
                <ul className="mt-3 space-y-2">
                  {column.items.map((item) => (
                    <li key={item}>
                      <Link
                        to={`/list/${encodeURIComponent(item)}`}
                        className="text-[13px] text-background-200/70 transition hover:text-accent-400"
                      >
                        {item}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 border-t border-background-100/10 pt-8 lg:grid-cols-[2fr_1fr]">
          <div>
            <h4 className="text-sm font-medium text-background-50">本周热门</h4>
            <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2">
              {hot.map((item) => (
                <Link
                  key={item.id}
                  to={`/detail/${item.id}`}
                  className="text-[13px] text-background-200/70 transition hover:text-accent-400"
                >
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
          <div className="lg:text-right">
            <h4 className="text-sm font-medium text-background-50">联系我们</h4>
            <a href="mailto:hello@boluomi.film" className="mt-3 block text-[13px] text-background-200/70 transition hover:text-accent-400">
              hello@boluomi.film
            </a>
            <p className="mt-1 text-[13px] text-background-200/50">工作日 10:00 - 18:00 回复</p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-2 px-4 py-5 text-[12px] text-background-200/50 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© 2026 菠萝蜜网 Boluomi Cinema. 保留所有权利。内容均为演示用途。</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition hover:text-accent-400">关于我们</Link>
            <Link to="/about#privacy" className="transition hover:text-accent-400">隐私政策</Link>
            <Link to="/about#disclaimer" className="transition hover:text-accent-400">免责声明</Link>
            <span className="hidden md:inline">当前路径 {location.pathname}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}